import { connect } from 'react-redux';
import { subscribeToDealDidgestBySSID } from '@/finsight/application/actions/deals/actions';
import dealsSelectors from '@/finsight/application/actions/deals/selectors';
import SubscribeButton from '@/finsight/ui/common/components/SubscribeButton';

const mapStateToProps = (state) => ({
  isSubscribed: dealsSelectors.getIsSubscribed(state),
  isFetching: dealsSelectors.getIsSubscriptionsFetching(state),
  isSpinnerVisible: dealsSelectors.getIsModalSpinnerVisible(state),
  subscriptionId: dealsSelectors.getSubscriptionId(state),
});

const mapDispatchToProps = {
  subscribeBySSID: subscribeToDealDidgestBySSID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubscribeButton);
